import * as React from 'react';
import { LinkButton, UIHeading4 } from '@cian/ui-kit';
import * as styles from './SeoSubtitles.css';

import { IconActionMap16 } from '@cian/ui-kit-design-tokens/icons';

interface ISeoSubtitlesProps {
  subtitle?: string;
  mapFullUrl?: string;
}
export const SeoSubtitles: React.FC<ISeoSubtitlesProps> = ({ mapFullUrl, subtitle }) => {
  return (
    <div className={styles['subtitles']}>
      {subtitle && <UIHeading4 data-testid="Subtitle">{subtitle}</UIHeading4>}
      {mapFullUrl && (
        <div className={styles['map-button']}>
          <LinkButton
            href={mapFullUrl}
            target="_blank"
            size="XS"
            theme={'fill_white_primary'}
            beforeIcon={<IconActionMap16 color="icon-main-default" />}
            data-testid="MapLink"
          >
            На карте
          </LinkButton>
        </div>
      )}
    </div>
  );
};
